<template>
  <div class="search">
    <!-- 输入栏开始 -->
    <div class="top_search">
      <van-form>
         <van-field  v-model="value" placeholder="请输入关键词">
          <template #left-icon>
            <Popover :actions="actions" @select="select" />
          </template>
        </van-field>
      </van-form>
    </div>
    <!-- 输入栏结束 -->
    <PullRefresh v-model="isLoading" @refresh="init">
      <Empty
        v-if="detail.totalCount === 0"
        tip="暂无内容"
      ></Empty>
      <van-list
        v-else
        v-model="detail.loading"
        :finished="detail.finished"
        finished-text="没有更多了"
        :offset="100"
        @load="getDetail"
      >
        <!-- 列表开始 -->
        <div class="section">
          <div class="box" v-for="(item,index) in detail.list" :key="index" @click="$router.push({name:'SearchDetail',query:{id:item.id}})">
            <div class="box_title">
              <div class="badge" :class="tag[item.activityStatus].bg">
                <div class="txt">
                  {{tag[item.activityStatus].name}}
                </div>
              </div>
              <van-image :src="item.image" class="img" fit="cover"></van-image>
            </div>
            <div class="box_content">
              <div class="title">{{ item.name }}</div>
              <div class="text">
                活动时间：{{ item.startDate | formatDate('yyyy-MM-dd') }} - {{ item.endDate | formatDate('yyyy-MM-dd') }}
              </div>
            </div>
          </div>
        </div>
        <!-- 列表结束 -->
      </van-list>
    </PullRefresh>
  </div>
</template>

<script>
import { Form, Field, PullRefresh } from 'vant';
import { mapGetters } from 'vuex';
import { Popover } from '@/components';
export default {
  components: {
    'van-form': Form,
    'van-field': Field,
    Popover,
    PullRefresh
  },
  data () {
    return {
      value: '', // 输入框值
      showPopover: false,
      // 通过 actions 属性来定义菜单选项
      actions: [{ text: '全部', id: 0 }, { text: '进行中', id: 2 }, { text: '已结束', id: 3 }],
      isLoading: false,
      // 活动列表
      list: [],

      tag: {
        2: { bg: 'bg-1', name: '正在进行中' },
        3: { bg: 'bg-2', name: '活动已结束' }
      },

      status: 0, // 选择的状态
      /* 详情页信息 */
      detail: {
        finished: false,
        loading: false,
        list: [],
        totalCount: '',
        pageNo: 1,
        pageSize: 10
      },

      /* 输入框防抖使用 */
      debounce: {
        ms: 300,
        timeID: ''
      }
    };
  },
  computed: {
    ...mapGetters(['personInfo'])
  },
  watch: {
    value: {

      /* 输入框输入值时调用接口并且添加防抖事件 */
      handler (newValue) {
        let { debounce } = this;
        clearTimeout(debounce.timeID);
        debounce.timeID = setTimeout(() => {
          this.init();
        }, debounce.ms);
      }
    }
  },

  mounted () {
    const { $route: { meta }, personInfo: { role } } = this;
    meta.title = role === 'STUDENT' ? '拓展活动' : '热门活动';
  },

  methods: {

    /* 初始化列表数据 */
    init () {
      this.detail = {
        finished: false,
        loading: true,
        list: [],
        totalCount: '',
        pageNo: 1,
        pageSize: 10
      };

      this.getDetail();
      this.isLoading = false;
    },

    /* 获取详情信息 */
    getDetail () {
      const { $http, status, value, detail: { pageNo, pageSize } } = this;
      let { detail } = this;
      $http.get('student/activity/list', {
        params: {
          pageNo,
          pageSize,
          status,
          keyword: value,
          type: 1
        }
      }).then((res) => {
        const { isHasNext, nextPage, result, totalCount } = res.data.page || {};

        detail.finished = !isHasNext;
        detail.loading = false;
        detail.pageNo = nextPage;
        detail.totalCount = totalCount;
        detail.list.push(...result);

        this.detail = detail;
      });
    },

    /* 下拉选择 */
    select (e) {
      this.status = e.id;
      this.init();
    }

  }

};
</script>

<style scoped lang="less">
  .search{
    display: flex;
    flex-direction: column;
    .top_search{
      padding: 28px 20px 0;
      background: #fff;
      padding-bottom: 38px;
      position: fixed;
      /*top: 69px;*/
      z-index: 99;
      left: 0;
      right: 0;
      /deep/
      .popover{
        display: flex;
        align-items: center;
        &::after{
          content: "";
          display: inline-block;
          width: 0px;
          height: 28px;
          margin: 0 32px;
          border: .1px solid #DDDEE6;
        }
      }
      .van-form{
        .van-cell{
          border-radius: 36px;
          background: #F7F8FA;
          .img{
            width:20px;
            height: 20px;
            display: inline-block;
            margin-left: 10px;
          }
          .van-field__control{
            padding-left: 32px;
          }
        }
      }
    }
    .section{
      flex: 1;
      padding: 137px 20px 0px;
      width: 100%;
      height: 100%;
      overflow-y: scroll;
      margin-top: 30px;
      .box{
        width: 100%;
        background: #FFFFFF;
        box-shadow: 0px 6px 60px rgba(0, 0, 0, 0.04);
        margin-bottom: 30px;
        &:last-child{
          margin-bottom: 0;
        }
        .box_title{
          position: relative;
          .img{
            width: 100%;
            height: 344px;
          }
          .badge {
            position: absolute;
            top: -10px;
            left: 0;
            z-index: 2;
            .txt{
              min-width: 110px;
              height: 48px;
              text-align: center;
              line-height: 48px;
              font-size: 24px;
              color: #FFFFFF;
              padding-left: 20px;
              padding-right: 20px;
              border-radius: 12px 0 12px 0;
              position: relative;
              z-index: 1;
            }
            &:after{
              content: '';
              width: 0;
              height: 0;
              border: 6px solid transparent;
              border-top-width: 0;
              border-bottom-width: 10px;
              overflow: hidden;
              position: absolute;
              left: 100%;
              top: 0;
              transform: translateX(-6px);
              z-index: -1;
            }
            &.bg-1{
              .txt {
                background-image: linear-gradient(270deg, #FF7643 0%, #FF5A7A 100%);
                background-color: #FF7643;
              }
              &:after{
                border-bottom-color: #D95423;
              }
            }
            &.bg-2{
              .txt {
                background-image: linear-gradient(270deg, #C3C0C0 0%, #B2B1B1 100%);
                background-color: #C3C0C0;
              }
              &:after{
                border-left-color: #A29F9F;
                border-bottom-color: #A29F9F;
              }
            }
          }
        }
        .box_content{
          padding: 28px;
          box-sizing: border-box;
          background-color: #fff;
          .title{
            font-size: 30px;
            font-weight: bold;
            line-height: 42px;
            color: #333444;
            .text-overflow();
            margin-bottom: 12px;
          }
          .text{
            font-size: 24px;
            line-height: 34px;
            color: #999AAA;
          }
        }
      }
    }
  }


</style>
